
import Vue from "vue";
import PanelMenu from "../PanelMenu.vue";
import store from "@/store";

export default Vue.extend({
  name: "AppHeader",
  components: {
    PanelMenu,
  },
  data() {
    return {
      searchText: "",
    };
  },
  methods: {
    search(): void {
      // if user has written something, search it. If not, just focus on search input
      if (!this.searchText.length) {
        (this as any).$refs.searchInput.focus();
      } else {
        // search script here
      }
    },
    switchTheme(): void {
      store.dispatch("app/switchTheme", {
        theme: null,
        component: this,
      });
    },
  },
  computed: {
    // mode setting
    themeModeIcon(): string {
      return store.state.app.theme === "light"
        ? "mdi-weather-night"
        : "mdi-weather-sunny";
    },
  },
});
